// Retry policy for printer-busy contention.
// occupied TCP port typically clears within a few seconds.
//
// The base delay plus a uniform random jitter prevents two contending
// terminals from synchronising their retries and colliding again on the
// same port the moment it frees.
export const PRINTER_BUSY_BASE_DELAY_MS = 500;
export const PRINTER_BUSY_JITTER_MS = 5000;
export const PRINTER_BUSY_MAX_RETRIES = 10;

// Only for the "printer busy" notification ("please wait N s"); the retries use the constants above.
export const PRINTER_BUSY_NOTIFICATION_WAIT_SECONDS = (PRINTER_BUSY_MAX_RETRIES * (PRINTER_BUSY_BASE_DELAY_MS + PRINTER_BUSY_JITTER_MS)) / 1000;

// J5: after a print burst finishes, wait this long before resuming printer discovery. A
// payment→kitchen burst enqueues its receipts with short gaps; the debounce keeps discovery
// paused across the whole burst and only resumes once the queue has been idle. A concurrent
// LAN discovery scan otherwise contends with the print connection (getPort seen inflating to
// ~6s and causing "Printer is power off" connect failures).
export const DISCOVERY_RESUME_DEBOUNCE_MS = 4000;
